import { memo, SVGProps } from 'react';

const IconMail = (props: SVGProps<SVGSVGElement>) => (
  <svg preserveAspectRatio='none' viewBox='0 0 113 69' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect width={112.579} height={69} rx={0.8} stroke='currentColor' strokeWidth={6} />
    <path
      d='M111.779 0H0.8C0.358172 0 0 0.358172 0 0.8V11.0726C0 11.3219 0.116224 11.5569 0.314326 11.7083L55.8041 54.1026C56.0909 54.3217 56.4888 54.3217 56.7755 54.1026L112.265 11.7083C112.463 11.5569 112.579 11.3219 112.579 11.0726V0.8C112.579 0.358172 112.221 0 111.779 0Z'
      stroke='currentColor'
      strokeWidth={6}
    />
  </svg>
);

const Memo = memo(IconMail);
export { Memo as IconMail };
